import { saveStatistic } from './../api'

export const sendStatistic = async (session: string | null, qrTypeRoute: string | null) => {
  if (session && qrTypeRoute && (qrTypeRoute === 'precheck' || qrTypeRoute === 'precheck2')) {
    await saveStatistic(session, 'precheck')
  }
}
